export function AppLogo() {
    return (
        <div className="flex items-center">
            <div className="w-8 h-8 mr-2 rounded-lg flex items-center justify-center text-xs font-bold tracking-wide bg-slate-800 text-white dark:bg-slate-100 dark:text-slate-900">
                SP
            </div>
            <span className="text-xl font-semibold text-slate-900 dark:text-white tracking-tight">
                SimPilot
            </span>
        </div>
    );
}
